import { MUT_ALTERS } from "./mut-columns.js";

export const recurrenceOverridesTable = `
CREATE TABLE IF NOT EXISTS recurrence_overrides (
  id                 TEXT PRIMARY KEY,
  recurrence_id      TEXT NOT NULL,
  recurrence_id_ref  TEXT NOT NULL,
  range              TEXT NOT NULL,
  status             TEXT,
  snoozed_until      TEXT,
  due_at             TEXT,
  duration_minutes   INTEGER,
  title              TEXT,
  notes              TEXT,
  priority           TEXT,
  custom_color       TEXT,
  all_day            INTEGER,
  rrule              TEXT,
  mut                INTEGER NOT NULL DEFAULT 0,
  server_acked_mut   INTEGER NOT NULL DEFAULT 0,
  google_acked_mut   INTEGER NOT NULL DEFAULT 0,
  created_at         TEXT NOT NULL,
  updated_at         TEXT NOT NULL,
  deleted_at         TEXT
);
`.trim();

export const recurrenceOverridesIndexes = [
  "CREATE INDEX IF NOT EXISTS idx_overrides_recurrence ON recurrence_overrides(recurrence_id);",
  "CREATE INDEX IF NOT EXISTS idx_overrides_recid_ref ON recurrence_overrides(recurrence_id, recurrence_id_ref);",
];

export const recurrenceOverridesAlters = [
  "ALTER TABLE recurrence_overrides ADD COLUMN snoozed_until TEXT;",
  ...MUT_ALTERS("recurrence_overrides"),
];
